import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseFormComponent } from '../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';
import { CodeDisplayCheckedModel, MultipleCheckboxCommonFunctions } from './multiple-checkbox.common.functions';


@Component({
  selector: 'app-multiple-checkbox[formGroup][propertyName]',
  templateUrl: './multiple-checkbox.component.html',
  styles: [],
  standalone: false,
})

export class MultipleCheckboxComponent extends BaseFormComponent { 
  @Input() subText?: string; 
  @Input() listData?: CodeDisplayCheckedModel[];
  @Input() checkAllMessage?: string;
  @Output() userInput? = new EventEmitter<any>();
  @Input() FIELD_SPACING: number

  constructor(private commonFunctions: CommonFunctions,
    private multipleCheckboxCommonFunctions: MultipleCheckboxCommonFunctions) {
    super(commonFunctions);
  }

  userAction(code: string, isChecked: boolean) {
    try {
        if (this.formGroup.get(this.propertyName) != undefined) {
          const result = this.multipleCheckboxCommonFunctions.updateMultipleCheckList(this.listData, code, isChecked);     
          this.formGroup.get(this.propertyName).setValue(result); 
          this.userInput.emit({
            code: code,
            isChecked: isChecked,
            value: result
          });
        }
     
     } catch(ex) {
       console.log('[MultipleCheckboxComponent] this.propertyName='+ this.propertyName +' userAction ex' + ex.message);
     } 
  } 
  
}
